import { Option, useDropdownSearchQuery } from '@tlx/atlas';

export function TaxcardYearDropdownOptions() {
    const taxcardYearSearch = useDropdownSearchQuery();
    const options = getTaxcardYearOptions().options;
    const filteredOptions = options?.filter((year) => year.includes(taxcardYearSearch));
    return (
        <>
            {filteredOptions?.map((year) => (
                <Option key={year} value={year}>
                    {year}
                </Option>
            ))}
        </>
    );
}

export function getTaxcardYearOptions() {
    const today = new Date();
    //First day you get to order next years cards - according to TaxDeductionCardsOrderer.java
    const firstOrderMonthDay = new Date(today.getFullYear(), 11, 15);

    const year = firstOrderMonthDay < today ? today.getFullYear() + 1 : today.getFullYear();

    function yearOptions(latestAllowedYear: number) {
        return Array.from({ length: latestAllowedYear - 2019 + 1 }, (_, i) => (latestAllowedYear - i).toString());
    }
    const options = yearOptions(year);

    return {
        year: year.toString(),
        options,
    };
}
